/* eslint-disable */
import { Box, Flex, Grid, Icon, Text, Spinner, Heading, Select, Button, Avatar, VStack, HStack, useColorModeValue } from "@chakra-ui/react";
import React, { useEffect, useState, useRef } from "react";
import { Bar, Doughnut } from "react-chartjs-2";
import "chart.js/auto";

import { BiMale } from "react-icons/bi";
import { FaGraduationCap } from "react-icons/fa";
import { FiCheckCircle, FiDownload } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { getStats } from "../../Redux/AdminReducer/action";
import axios from "axios";

const DashBoard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  
  const [engagementData, setEngagementData] = useState(null);
  const [engagementPeriod, setEngagementPeriod] = useState("month"); // day, week, month, year
  const [lnaTelemetry, setLnaTelemetry] = useState(null);
  
  const [reportStartDate, setReportStartDate] = useState("");
  const [reportEndDate, setReportEndDate] = useState("");
  
  const dispatch = useDispatch();

  const cardBg = useColorModeValue("white", "rgba(15, 23, 42, 0.7)");
  const cardBorder = useColorModeValue("gray.100", "rgba(255, 255, 255, 0.08)");
  const headingColor = useColorModeValue("gray.800", "white");
  const textColor = useColorModeValue("gray.500", "gray.300");
  const iconBg = useColorModeValue("gray.100", "rgba(255, 255, 255, 0.05)");
  const iconColor = useColorModeValue("gray.600", "gray.300");
  const selectBg = useColorModeValue("gray.50", "rgba(15, 23, 42, 0.5)");
  const infoBg = useColorModeValue("purple.50", "rgba(107, 70, 193, 0.15)");
  const infoBorder = useColorModeValue("purple.100", "rgba(107, 70, 193, 0.25)");
  const infoText = useColorModeValue("purple.800", "purple.200");
  const topStudentBgValue = useColorModeValue(null, "rgba(255, 255, 255, 0.03)");
  const topStudentBorderColor = useColorModeValue(null, "rgba(255, 255, 255, 0.05)");
  const topStudentBorder = useColorModeValue("none", "1px solid");
  const gridLineColor = useColorModeValue("rgba(0,0,0,0.05)", "rgba(255,255,255,0.05)");
  const progressBg = useColorModeValue("blackAlpha.100", "whiteAlpha.100");

  useEffect(() => {
    dispatch(getStats()).then(data => {
      if (data) setStats(data);
      setLoading(false);
    });
  }, [dispatch]);

  useEffect(() => {
    const fetchEngagement = async () => {
      try {
        const token = JSON.parse(localStorage.getItem('user'))?.token || "";
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/reports/engagement?period=${engagementPeriod}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setEngagementData(res.data);
      } catch (err) {
        console.error("Failed to load engagement data", err);
      }
    };

    const fetchLnaTelemetry = async () => {
      try {
        const token = JSON.parse(localStorage.getItem('user'))?.token || "";
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/lna/telemetry`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        if (res.data && res.data.length > 0) {
          const vibrantColors = ['#7c3aed', '#0ea5e9', '#10b981', '#f59e0b', '#c026d3', '#ef4444'];
          setLnaTelemetry({
            labels: res.data.map(d => d.category),
            datasets: [{
              label: 'Avg Difficulty Score',
              data: res.data.map(d => d.averageDifficulty),
              backgroundColor: res.data.map((_, i) => vibrantColors[i % vibrantColors.length]),
              borderColor: cardBg,
              borderWidth: 3,
              hoverOffset: 6
            }]
          });
        }
      } catch (err) {
        console.error("Failed to fetch LNA telemetry", err);
      }
    };

    fetchEngagement();
    fetchLnaTelemetry();
  }, [engagementPeriod]);

  const handleDownloadExcel = () => {
    const token = JSON.parse(localStorage.getItem('user'))?.token || "";
    let url = `${process.env.REACT_APP_API_URL}/api/reports/progress/excel?token=${token}`;
    if (reportStartDate) url += `&startDate=${reportStartDate}`;
    if (reportEndDate) url += `&endDate=${reportEndDate}`;
    window.open(url, '_blank');
  };
  const handleDownloadCSV = () => {
    const token = JSON.parse(localStorage.getItem('user'))?.token || "";
    let url = `${process.env.REACT_APP_API_URL}/api/reports/progress/csv?token=${token}`;
    if (reportStartDate) url += `&startDate=${reportStartDate}`;
    if (reportEndDate) url += `&endDate=${reportEndDate}`;
    window.open(url, '_blank');
  };
  const handleDownloadPDF = () => {
    const token = JSON.parse(localStorage.getItem('user'))?.token || "";
    let url = `${process.env.REACT_APP_API_URL}/api/reports/progress/pdf?token=${token}`;
    if (reportStartDate) url += `&startDate=${reportStartDate}`;
    if (reportEndDate) url += `&endDate=${reportEndDate}`;
    window.open(url, '_blank');
  };

  const bgMain = useColorModeValue("var(--background)", "gray.900");

  return (
    <Box mt={{ base: -4, md: -8 }} mx={{ base: -4, md: -8 }} w="auto" bg={bgMain} minH="100vh" pb={10} px={{ base: 4, md: 8, lg: 10 }} pt={6}>
        {/* PREMIUM CORPORATE SUPERADMIN BANNER */}
        <Box mb={4}>
          <Box 
            bg={useColorModeValue("linear-gradient(135deg, #942F67 0%, #A9A4C9 100%)", "linear-gradient(135deg, #7a2554 0%, #4a1733 100%)")}
            p={5}
            borderRadius="2xl"
            position="relative"
            overflow="hidden"
            boxShadow={useColorModeValue("var(--shadow-glow)", "0 20px 40px -15px rgba(0, 0, 0, 0.4)")}
          >
            {/* Abstract Background Shapes for Banner */}
            <Box position="absolute" top="-20px" right="-20px" w="150px" h="150px" bg="#A9A4C9" borderRadius="50%" filter="blur(40px)" opacity={0.6} zIndex={0} />
            <Box position="absolute" bottom="-20px" left="10%" w="120px" h="120px" bg="#D08F6B" borderRadius="50%" filter="blur(30px)" opacity={0.5} zIndex={0} />
            
            <Flex position="relative" zIndex={1} justify="space-between" align="center" direction={{ base: "column", md: "row" }} gap={6}>
              <Box color="white">
                <Text fontSize="xs" fontWeight="800" textTransform="uppercase" letterSpacing="1px" mb={2} opacity={0.9}>
                  ⭐ Administrator Command Center
                </Text>
                <Heading size="md" fontWeight="850" mb={1} letterSpacing="-0.5px">
                  Employee Statistics & Telemetry
                </Heading>
                <Text fontSize="xs" opacity={0.9} fontWeight="600">
                  Real-time metric counters and operational telemetry for your academy
                </Text>
              </Box>
              <HStack spacing={3}>
                <Box display="flex" gap={2} alignItems="center">
                  <Text fontSize="10px" color="whiteAlpha.800" fontWeight="bold">FROM:</Text>
                  <input 
                    type="date" 
                    value={reportStartDate} 
                    onChange={(e) => setReportStartDate(e.target.value)} 
                    style={{ fontSize: '12px', padding: '4px', borderRadius: '6px', border: 'none', outline: 'none', width: '110px' }}
                  />
                  <Text fontSize="10px" color="whiteAlpha.800" fontWeight="bold">TO:</Text>
                  <input 
                    type="date" 
                    value={reportEndDate} 
                    onChange={(e) => setReportEndDate(e.target.value)} 
                    style={{ fontSize: '12px', padding: '4px', borderRadius: '6px', border: 'none', outline: 'none', width: '110px' }}
                  />
                </Box>
                <Button 
                  as={require('react-router-dom').Link}
                  to="/admin/upload-lna-quiz"
                  bg="#D08F6B"
                  color="white"
                  borderRadius="full"
                  fontSize="xs"
                  fontWeight="800"
                  h="46px"
                  px={6}
                  boxShadow="0 4px 15px rgba(0,0,0,0.1)"
                  _hover={{ transform: "translateY(-2px)", boxShadow: "0 6px 20px rgba(0,0,0,0.15)" }}
                  transition="all 0.2s"
                >
                  Upload LNA Quiz
                </Button>
                <Button 
                  bg="whiteAlpha.200"
                  color="white"
                  borderRadius="full"
                  fontSize="xs"
                  fontWeight="700"
                  h="46px"
                  px={5}
                  border="1px solid rgba(255,255,255,0.2)"
                  _hover={{ bg: "whiteAlpha.300" }}
                  onClick={handleDownloadCSV}
                >
                  Export CSV
                </Button>
                <Button 
                  bg="white"
                  color="#942F67"
                  borderRadius="full"
                  fontSize="xs"
                  fontWeight="800"
                  h="46px"
                  px={6}
                  boxShadow="0 4px 15px rgba(0,0,0,0.1)"
                  _hover={{ transform: "translateY(-2px)", boxShadow: "0 6px 20px rgba(0,0,0,0.15)" }}
                  transition="all 0.2s"
                  onClick={handleDownloadExcel}
                >
                  Export Excel
                </Button>
                <Button 
                  leftIcon={<FiDownload />} 
                  bg="#D08F6B"
                  color="white"
                  borderRadius="full"
                  fontSize="xs"
                  fontWeight="800"
                  h="46px"
                  px={6}
                  boxShadow="0 4px 15px rgba(0,0,0,0.1)"
                  _hover={{ transform: "translateY(-2px)", boxShadow: "0 6px 20px rgba(0,0,0,0.15)", bg: "#b57855" }}
                  transition="all 0.2s"
                  onClick={handleDownloadPDF}
                >
                  Export PDF
                </Button>
              </HStack>
            </Flex>
          </Box>
        </Box>

        {/* ── Metric Cards Row ── */}
        <Grid templateColumns={{ base: "1fr", md: "repeat(3, 1fr)", xl: "repeat(5, 1fr)" }} gap={4} mb={4}>
          <Box bg="#7c3aed" borderRadius="2xl" p="14px 16px" display="flex" flexDirection="column" gap={1}>
            <Flex fontSize="11px" fontWeight="700" textTransform="uppercase" letterSpacing="0.5px" color="whiteAlpha.800" align="center" gap={2}>
              <Icon as={BiMale} boxSize={4} /> Total employees
            </Flex>
            <Box fontSize="28px" fontWeight="800" color="white" lineHeight="1.1">
              {loading ? <Spinner size="sm" /> : stats?.totalStudents || 0}
            </Box>
            <Text fontSize="11px" color="whiteAlpha.600" fontWeight="600">{stats?.activeStudents || 0} active</Text>
          </Box>

          <Box bg="#0ea5e9" borderRadius="2xl" p="14px 16px" display="flex" flexDirection="column" gap={1}>
            <Flex fontSize="11px" fontWeight="700" textTransform="uppercase" letterSpacing="0.5px" color="whiteAlpha.800" align="center" gap={2}>
              <Icon as={FaGraduationCap} boxSize={4} /> Total courses
            </Flex>
            <Box fontSize="28px" fontWeight="800" color="white" lineHeight="1.1">
              {loading ? <Spinner size="sm" /> : stats?.totalCourses || 0}
            </Box>
            <Text fontSize="11px" color="whiteAlpha.600" fontWeight="600">Across all depts</Text>
          </Box>

          <Box bg="#10b981" borderRadius="2xl" p="14px 16px" display="flex" flexDirection="column" gap={1}>
            <Flex fontSize="11px" fontWeight="700" textTransform="uppercase" letterSpacing="0.5px" color="whiteAlpha.800" align="center" gap={2}>
              <Icon as={FiCheckCircle} boxSize={4} /> Avg learning time
            </Flex>
            <Box fontSize="28px" fontWeight="800" color="white" lineHeight="1.1">
              {loading ? <Spinner size="sm" /> : stats?.avgLearningTime || "0h"}
            </Box>
            <Text fontSize="11px" color="whiteAlpha.600" fontWeight="600">Per employee</Text>
          </Box>

          <Box bg="#f59e0b" borderRadius="2xl" p="14px 16px" display="flex" flexDirection="column" gap={1}>
            <Flex fontSize="11px" fontWeight="700" textTransform="uppercase" letterSpacing="0.5px" color="whiteAlpha.800" align="center" gap={2}>
              <Icon as={FaGraduationCap} boxSize={4} /> Completion rate
            </Flex>
            <Box fontSize="28px" fontWeight="800" color="white" lineHeight="1.1">
              {loading ? <Spinner size="sm" /> : `${stats?.completionRate || 0}%`}
            </Box>
            <Text fontSize="11px" color="whiteAlpha.600" fontWeight="600">Needs attention</Text>
          </Box>

          {/* Top Employee Snippet */}
          <Box bg={cardBg} borderRadius="2xl" p="14px 16px" border="1px solid" borderColor={cardBorder}>
            <Flex fontSize="11px" color={textColor} align="center" gap={2} mb={3} fontWeight="700">
              <Icon as={FaGraduationCap} color="#fbbf24" boxSize={4} /> Top employee
            </Flex>
            {loading ? <Spinner size="sm" /> : stats?.topStudents?.length > 0 ? (
              <Flex align="center" gap={3}>
                <Avatar size="sm" name={stats.topStudents[0].name} bg="#7c3aed" color="white" />
                <Box flex={1} minW={0}>
                  <Text fontSize="13px" fontWeight="700" color={headingColor} isTruncated>{stats.topStudents[0].name}</Text>
                  <Text fontSize="10px" color={textColor} fontWeight="600" isTruncated>{stats.topStudents[0].email}</Text>
                </Box>
                <Box textAlign="right" flexShrink={0}>
                  <Text fontSize="14px" fontWeight="800" color="#10b981">{stats.topStudents[0].score}%</Text>
                  <Text fontSize="10px" color={textColor} fontWeight="600">{stats.topStudents[0].completedCourses} courses</Text>
                </Box>
              </Flex>
            ) : (
              <Text fontSize="xs" color={textColor}>No data</Text>
            )}
          </Box>
        </Grid>
        <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={8} mb={10}>
          {/* Engagement Ratio Graph */}
          <Flex 
            bg={cardBg} 
            p={6} 
            borderRadius="3xl" 
            boxShadow="sm" 
            border="1px solid" 
            borderColor={cardBorder}
            direction="column"
          >
            <Flex justify="space-between" align="center" mb={6}>
              <Text fontSize="lg" fontWeight="800" color={headingColor}>
                📈 System Engagement
              </Text>
              <Select 
                w="150px" 
                size="sm" 
                borderRadius="xl" 
                bg={selectBg} 
                color={headingColor}
                value={engagementPeriod}
                onChange={(e) => setEngagementPeriod(e.target.value)}
              >
                <option value="day">This Day</option>
                <option value="week">This Week</option>
                <option value="month">This Month</option>
                <option value="year">This Year</option>
              </Select>
            </Flex>
            
            <Box h="220px" w="full">
              {engagementData ? (
                <Bar 
                  data={engagementData} 
                  options={{ 
                    maintainAspectRatio: false,
                    scales: {
                      y: {
                        beginAtZero: true,
                        grid: { color: gridLineColor }
                      },
                      x: {
                        grid: { display: false }
                      }
                    }
                  }} 
                />
              ) : (
                <Flex h="100%" justify="center" align="center"><Spinner color="#10b981" /></Flex>
              )}
            </Box>
          </Flex>

          {/* Global LNA Telemetry Graph */}
          {lnaTelemetry && (
            <Flex 
              bg={cardBg} 
              p={4} 
              borderRadius="2xl" 
              boxShadow="sm" 
              border="1px solid" 
              borderColor={cardBorder}
              direction="column"
            >
              <Flex justify="space-between" align="center" mb={6}>
                <Box>
                  <Text fontSize="lg" fontWeight="800" color={headingColor}>
                    🧠 Global Learning Needs Analysis
                  </Text>
                  <Text fontSize="xs" color={textColor} fontWeight="600">
                    Difficulty Scores Across Organization
                  </Text>
                </Box>
              </Flex>
              
              <Flex align="center" gap={6} flex={1}>
                <Box position="relative" w="155px" h="155px" flexShrink={0}>
                  <Doughnut 
                    data={lnaTelemetry} 
                    options={{ 
                      responsive: true, 
                      maintainAspectRatio: false,
                      cutout: "68%",
                      plugins: { legend: { display: false } }
                    }} 
                    plugins={[{
                      id: "centerText",
                      beforeDraw(chart) {
                        const { width, height, ctx } = chart;
                        ctx.restore();
                        const datasets = chart.config.data.datasets;
                        if (!datasets || !datasets[0] || !datasets[0].data || datasets[0].data.length === 0) return;
                        const dataArray = datasets[0].data;
                        const sum = dataArray.reduce((a, b) => Number(a) + Number(b), 0);
                        const avg = Math.round(sum / dataArray.length);
                        
                        ctx.font = "800 22px Inter, system-ui, sans-serif";
                        ctx.textBaseline = "middle";
                        ctx.fillStyle = headingColor === "white" ? "#fff" : "#1a202c";
                        const textX = Math.round((width - ctx.measureText(avg).width) / 2);
                        ctx.fillText(avg, textX, height / 2 - 8);
                        
                        ctx.font = "600 10px Inter, system-ui, sans-serif";
                        ctx.fillStyle = textColor === "gray.300" ? "#a0aec0" : "#718096";
                        const sub = "avg score";
                        const subX = Math.round((width - ctx.measureText(sub).width) / 2);
                        ctx.fillText(sub, subX, height / 2 + 12);
                        ctx.save();
                      }
                    }]}
                  />
                </Box>
                <Flex direction="column" gap={3} flex={1}>
                  {lnaTelemetry.labels.map((label, idx) => {
                    const score = lnaTelemetry.datasets[0].data[idx];
                    const color = lnaTelemetry.datasets[0].backgroundColor[idx];
                    return (
                      <Flex key={label} align="center" gap={3}>
                        <Box w="10px" h="10px" borderRadius="sm" bg={color} flexShrink={0} />
                        <Text fontSize="xs" color={textColor} flex={1} isTruncated>{label}</Text>
                        <Box flex={2} bg={progressBg} borderRadius="md" h="5px" overflow="hidden">
                          <Box w={`${score}%`} h="100%" bg={color} borderRadius="md" />
                        </Box>
                        <Text fontSize="11px" color={textColor} minW="26px" textAlign="right">{score}</Text>
                      </Flex>
                    );
                  })}
                </Flex>
              </Flex>
            </Flex>
          )}
        </Grid>
      </Box>
  );
};

export default DashBoard;
